import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/common/SEO';
import Breadcrumbs from '../../components/common/Breadcrumbs';

const HowToUse = () => {
  const cards = [
    { title: '請求書CSVアップロード', href: '/support/how-to-use/invoice-upload', desc: 'CSVファイルを使った請求書の一括発行・予約発行の手順' },
    { title: '顧客CSVアップロード', href: '/support/how-to-use/customer-upload', desc: 'Stripeへの顧客情報一括登録・更新の手順' },
    { title: '顧客データ削除', href: '/support/how-to-use/customer-delete', desc: 'CSVを使用した顧客データの一括削除手順' },
    { title: 'ご契約内容', href: '/support/how-to-use/subscription', desc: '利用プランの確認・変更・契約管理の方法' },
    { title: 'Billwave設定', href: '/support/how-to-use/billwave-settings', desc: 'Stripe APIキーの設定や税率IDの登録方法' },
    { title: 'お客様情報', href: '/support/how-to-use/customer-info', desc: '登録会社情報・担当者情報の変更方法' },
    { title: 'チーム管理', href: '/support/how-to-use/team-management', desc: 'メンバー招待やアクセス権限の設定方法' },
  ];

  const howToJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    'name': 'Billwaveの使い方ガイド',
    'description': 'Stripe連携による請求書CSV一括発行・顧客登録・チーム管理などの使い方手順解説です。',
    'step': cards.map(c => ({
      '@type': 'HowToStep',
      'name': c.title,
      'text': c.desc,
      'url': `https://billwave.jp${c.href}`
    }))
  };

  return (
    <>
      <SEO 
        title="Billwave利用ガイド｜Stripe請求書CSV一括発行の使い方"
        description="Billwaveの使い方ガイド。Stripe請求書のCSV一括アップロード手順、顧客データの一括登録・削除、契約管理、チーム権限設定まで、画像とステップ解説で初心者でも簡単に始められる請求書自動化の手順をご案内します。"
        path="/support/how-to-use"
        jsonLd={howToJsonLd}
      />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Breadcrumbs items={[{ label: '使い方' }]} />
        
        <div className="bg-white p-8 shadow-lg rounded-lg border border-gray-100">
          <h1 className="text-3xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-200">
            Billwave 使い方ガイド
          </h1>
          <p className="text-gray-700 mb-8 leading-relaxed">
            Billwaveをスムーズにご利用いただくための機能別ガイド一覧です。<br />
            各種機能の詳しい操作手順や設定方法は、以下のカードをクリックしてご確認ください。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {cards.map((card, index) => (
              <Link
                key={index}
                to={card.href}
                className="block p-6 bg-gray-50 border border-gray-200 rounded-lg shadow-sm hover:bg-blue-50 hover:border-blue-300 hover:shadow-md transition-all duration-200 text-left"
              >
                <h2 className="font-bold text-lg text-blue-700 mb-2">
                  {card.title}
                </h2>
                <p className="text-sm text-gray-600">
                  {card.desc}
                </p>
              </Link>
            ))}
          </div>

          <hr className="my-10 border-gray-200" />

          {/* Natural Internal Links & CTA */}
          <section className="bg-blue-50 rounded-xl p-6 text-center border border-blue-100">
            <h2 className="text-xl font-bold text-gray-900 mb-3">準備は整いましたか？</h2>
            <p className="text-sm text-gray-600 mb-6">
              フォーマットをまだダウンロードされていない方はCSVフォーマット仕様書をご確認ください。<br />
              無料アカウント登録で月5件までの請求書CSV一括発行をすぐにお試しいただけます。
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/support/csv-format" className="bg-white text-blue-600 border border-blue-600 hover:bg-blue-50 font-bold py-2.5 px-6 rounded-lg transition-colors">
                CSVフォーマットを確認する
              </Link>
              <Link to="/faq" className="bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 font-bold py-2.5 px-6 rounded-lg transition-colors">
                よくある質問を見る
              </Link>
              <Link to="/signup" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2.5 px-6 rounded-lg transition-colors shadow">
                無料で試してみる
              </Link>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default HowToUse;
